export const environment = {
    production: false,
    // 開発中もリモートサーバー(dev環境)のAPIを使う設定
    apiUrl: 'https://dev.creditscan.butinuki.co.jp/api'
};